export default __webpack_public_path__ + "static/media/7.0a9d1776.png";